import React from 'react';
import {View, StyleSheet} from 'react-native';
import {useSelector, useDispatch} from 'react-redux';
import i18n from 'i18n-js';
import ItemColumn from './ItemColumn';
import SuggestedPanel from './SuggestedPanel';
import ScanLanding from './ScanLanding';
import ToteSetSwitch from './ToteSetSwitch';
import ResponseView from '../scanpack/response_view';
import useWidth from '../scanToCartScanning/useWidth';
import {
  handleInput,
  redirectToProductDetail
} from '../../actions/productFirstActions';
import {selectToteIdentifier} from '../../selectors/productFirstSelectors';

const countPieces = items =>
  items.reduce((sum, item) => sum + (item.qty_remaining || 0), 0);

const PutWallScanHome = () => {
  const dispatch = useDispatch();
  const width = useWidth();
  const toteIdentifier = useSelector(selectToteIdentifier);
  const {order, suggestedItem, orderComplete, unscannedItems, itemsInTote, scanSuccess, scanError} =
    useSelector(state => ({
      order: state.productFirst.order,
      suggestedItem: state.productFirst.suggestedItem,
      orderComplete: state.productFirst.orderComplete,
      unscannedItems: state.productFirst.unscannedItems,
      itemsInTote: state.productFirst.itemsInTote,
      scanSuccess: state.productFirst.scanSuccess,
      scanError: state.productFirst.scanError
    }));
  const wide = width >= 900;

  const hasActiveScan =
    order || suggestedItem || orderComplete || itemsInTote.length > 0;

  return (
    <View style={styles.container} testID="putWallScanHome">
      {(scanSuccess || scanError) && (
        <ResponseView
          orderCompleteAction={false}
          scanSuccessAction={scanSuccess}
          scanFailAction={scanError}
        />
      )}

      <ToteSetSwitch />

      {!hasActiveScan ? (
        <ScanLanding
          caption={i18n.t('productFirst.scanProductPrompt')}
          placeholder={i18n.t('productFirst.scanProductPlaceholder')}
          onSubmit={() => dispatch(handleInput())}
        />
      ) : (
        <View style={styles.row}>
          {wide && (
            <View style={styles.side}>
              <ItemColumn
                title={i18n.t('productFirst.unscannedTitle', {
                  count: countPieces(unscannedItems)
                })}
                items={unscannedItems}
                listType="unscanned"
                onItemPress={item =>
                  dispatch(redirectToProductDetail(item.product_id))
                }
              />
            </View>
          )}

          <SuggestedPanel />

          {wide && (
            <View style={styles.side}>
              <ItemColumn
                title={i18n.t('productFirst.itemsInToteTitle', {
                  count: itemsInTote.length,
                  toteIdentifier
                })}
                items={itemsInTote}
                listType="scanned"
                onItemPress={item =>
                  dispatch(redirectToProductDetail(item.product_id))
                }
              />
            </View>
          )}
        </View>
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#4A6179'
  },
  row: {
    flex: 1,
    flexDirection: 'row'
  },
  side: {
    flex: 2,
    backgroundColor: '#4A6179'
  }
});

export default PutWallScanHome;
